import React from "react";
import { ReactComponent as Logo } from "../../Resources/Logos/logo.svg";

const Home = () => {
  return (
    <div className="home">
      <h1 style={{ color: "var(--primary-color)" }}>Marlene Riedl</h1>

      <Logo className="logo" />

      <div>
        <h2> Student at the University of Vienna.</h2>
        <h2> Specializing in IT/IP law.</h2>
      </div>
    </div>
  );
};

export default Home;
